module.exports = {
  "id": "af2697b5-7cd1-4917-8f84-a08307e4eacc",
  "gtmIds": [],
  "startTracking": "since_launch",
  "hasInAppVersion": true,
  "group": "spotlio",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US",
    "nb-NO"
  ],
  "website": "https://portfolio.spotlioapps.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}